import { render, staticRenderFns } from "./OrderRoundActions.vue?vue&type=template&id=53edefda&"
import script from "./OrderRoundActions.vue?vue&type=script&lang=js&"
export * from "./OrderRoundActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports